import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import {
    mapDispatchToProps as sourceMapDispatchToProps,
    mapStateToProps as sourceMapStateToProps,
    ProductPageContainer as SourceProductPageContainer,
} from 'SourceRoute/ProductPage/ProductPage.container';
import { hideActiveOverlay } from 'Store/Overlay/Overlay.action';
import ProductReducer from 'Store/Product/Product.reducer';
import { withReducers } from 'Util/DynamicReducer';

/** @namespace Advox/Route/ProductPage/Container/mapStateToProps */
export const mapStateToProps = (state) => ({
    ...sourceMapStateToProps(state),
    isTablet: state.ConfigReducer.device.isTablet,
    popupPayload: state.PopupReducer.popupPayload,
});

/** @namespace Advox/Route/ProductPage/Container/mapDispatchToProps */
export const mapDispatchToProps = (dispatch) => ({
    ...sourceMapDispatchToProps(dispatch),
    hidePopup: () => dispatch(hideActiveOverlay()),
});

/** @namespace Advox/Route/ProductPage/Container */
export class ProductPageContainer extends SourceProductPageContainer {
    containerFunctions = {
        ...this.containerFunctions,
        hidePopup: this.hidePopup.bind(this),
    };

    hidePopup() {
        const { hidePopup } = this.props;

        hidePopup();
    }

    _getIsAlternativeDesign() {
        const {
            product: { alternative_product_design = false },
        } = this.props;

        return !!alternative_product_design;
    }

    updateMeta() {
        const { updateMetaFromProduct } = this.props;
        const products = this.getDataSource();
        products.canonical_url = products?.mw_canonical_url?.url;
        updateMetaFromProduct(products);
    }

    containerProps() {
        const { isMobile, isTablet, location, popupPayload } = this.props;
        const { parameters } = this.state;

        return {
            areDetailsLoaded: this.getAreDetailsLoaded(),
            isAttributesTabEmpty: this.isProductAttributesTabEmpty(),
            isInformationTabEmpty: this.isProductInformationTabEmpty(),
            activeProduct: this.getActiveProductDataSource(),
            dataSource: this.getDataSource(),
            useEmptyGallerySwitcher: this.getUseEmptyGallerySwitcher(),
            isVariant: this.getIsVariant(),
            isMobile,
            isTablet,
            parameters,
            location,
            isPopupOpened: !!popupPayload.REVIEW_POPUP_ID,
            showAlternativeDesign: this._getIsAlternativeDesign() && !isTablet && !isMobile,
        };
    };
}

export default withReducers({
    ProductReducer,
})(withRouter(connect(mapStateToProps, mapDispatchToProps)(ProductPageContainer)));
